import React from "react";
import {useNavigate} from "react-router-dom";
import {PermanentMenu, PermanentMenuHeader} from "@bounce/shared/ui";
import {queryClient} from "@bounce/shared/requests";
import {useGetReachUser} from "../apis/requests/users/getReachUser";
import {useReachAuth} from "../hooks/useReachAuth";
import {reachMenuItems, reachUrls} from "./menu-items";

const MenuLayout = () => {
  const navigate = useNavigate();
  const {agentEmail} = useReachAuth();
  const {data: user, isLoading} = useGetReachUser({enabled: !!agentEmail});

  const onSignOut = () => {
    localStorage.removeItem("agentToken");
    queryClient.clear();
    navigate("/login");
  };

  const onHomeClick = () => {
    navigate(reachUrls.dashboard);
  };

  return (
    <PermanentMenu
      menuItems={reachMenuItems}
      header={
        <PermanentMenuHeader
          platform="reach"
          fullName={user?.full_name}
          email={agentEmail}
          isLoading={isLoading}
          onSignOut={onSignOut}
          onHomeClick={onHomeClick}
        />
      }
      platform="reach"
    />
  );
};

export default MenuLayout;
